import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import styled from 'styled-components';
import { get } from '../../styles/constant';
import { variant } from 'styled-system';
const fit = variant({
  prop: 'fit',
  variants: {
    'x-small': {
      fontSize: get('fontSizes.xs'),
      width: get('space.24'),
      height: get('space.24')
    },
    small: {
      fontSize: get('fontSizes.s'),
      width: get('space.32'),
      height: get('space.32')
    },
    medium: {
      fontSize: get('fontSizes.m'),
      width: get('space.40'),
      height: get('space.40')
    },
    large: {
      fontSize: get('fontSizes.l'),
      width: get('space.48'),
      height: get('space.48')
    },
    'x-large': {
      fontSize: get('fontSizes.l'),
      width: get('space.56'),
      height: get('space.56')
    },
    'xx-large': {
      fontSize: get('fontSizes.l'),
      width: get('space.64'),
      height: get('space.64')
    }
  }
});
const appearance = variant({
  prop: 'appearance',
  variants: {
    color1: {
      backgroundColor: get('colors.primary.blue.50'),
      color: get('colors.primary.blue.900')
    },
    color2: {
      backgroundColor: get('colors.secondary.teal.50'),
      color: get('colors.secondary.teal.900')
    },
    color3: {
      backgroundColor: get('colors.secondary.orange.50'),
      color: get('colors.secondary.orange.900')
    },
    color4: {
      backgroundColor: get('colors.secondary.red.50'),
      color: get('colors.secondary.red.900')
    }
  }
});
const variants = {
  fit,
  appearance
};
export const Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  border-radius: 50%;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  display: flex;\n  overflow: hidden;\n"])), variants.fit, variants.appearance);
export const Image = styled.img(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  display: flex;\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n"])));